import { API_TIMEOUT, getApiPath, getCommonHeaders, handleApiError, handleApiResponse } from "../config/api";

// module apis
export const getModuleList = async () => {
  try {
    const response = await fetch(`${getApiPath.systemModules}`, {
        method: "GET",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "getModuleList API");
  }
};


export const saveModules = async (payload:any) => {
  try {
    const response = await fetch(`${getApiPath.systemModules}`, {
        method: "POST",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
        body: JSON.stringify(payload),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "saveModules API");
  }
};

export const updateModules = async (payload:any,updateId:number) => {
  try {
    const response = await fetch(`${getApiPath.systemModules}/${updateId}`, {
        method: "PUT",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
        body: JSON.stringify(payload),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "updateModules API");
  }
};


export const deleteModules = async (delete_id:number) => {
  try {
    const response = await fetch(`${getApiPath.systemModules}/${delete_id}`, {
        method: "DELETE",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "deleteModules API");
  }
};

// Roles API's

export const saveRoles = async (payload:any) => {
  try {
    const response = await fetch(`${getApiPath.systemRoles}`, {
        method: "POST",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
        body: JSON.stringify(payload),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "saveRoles API");
  }
};

export const getRoleList = async () => {
  try {
    const response = await fetch(`${getApiPath.systemRoles}`, {
        method: "GET",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "getRoleList API");
  }
};

export const updateRoles = async (payload:any,updateId:number) => {
  try {
    const response = await fetch(`${getApiPath.systemRoles}/${updateId}`, {
        method: "PUT",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
        body: JSON.stringify(payload),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "updateRoles API");
  }
};

export const deleteRoles = async (delete_id:number) => {
  try {
    const response = await fetch(`${getApiPath.systemRoles}/${delete_id}`, {
        method: "DELETE",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "deleteRoles API");
  }
};

// User API's

export const saveUser = async (payload:any) => {
  try {
    const response = await fetch(`${getApiPath.systemUser}`, {
        method: "POST",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
        body: JSON.stringify(payload),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "saveUser API");
  }
};

export const getUsersList = async (offset:number, limit:number) => {
  try {
    const response = await fetch(`${getApiPath.systemUser}?offset=${offset}&limit=${limit}`, {
        method: "GET",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "getUsersList API");
  }
};

export const updateUser = async (payload:any,updateId:number) => {
  try {
    const response = await fetch(`${getApiPath.systemUser}/${updateId}`, {
        method: "PUT",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
        body: JSON.stringify(payload),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "updateRoles API");
  }
};

export const deleteUser = async (delete_id:number) => {
  try {
    const response = await fetch(`${getApiPath.systemUser}/${delete_id}`, {
        method: "DELETE",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "deleteRoles API");
  }
};

export const checkUserEmail = async (email:string) => {
  try {
    const response = await fetch(`${getApiPath.systemCheckUserEmail}?email=${email}`, {
        method: "GET",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "getUsersList API");
  }
};

export const checkUserName = async (username:string) => {
  try {
    const response = await fetch(`${getApiPath.systemCheckUserName}?username=${username}`, {
        method: "GET",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "getUsersList API");
  }
};

export const getUserDetailsByID = async (id:any) => {
  try {
    const response = await fetch(`${getApiPath.systemUser}/${id}`, {
        method: "GET",
        headers: getCommonHeaders(),
        signal: AbortSignal.timeout(API_TIMEOUT),
    });
    return await handleApiResponse(response);
  } catch (err) {
    handleApiError(err, "getUsersList API");
  }
};

